import React, { useCallback, useEffect, useState } from 'react';
import { Card, Layout, Loading, Page } from '@shopify/polaris';
import { Prompt, useHistory } from 'react-router';
import { ContentPageType } from '../../api/spacex.types';
import { useClient } from '../../api/useClient';
import { ViewConfig } from '../../configEditor/ConfigEditor';
import { PhonePreviewLayout } from '../../configure/theme/preview/PhonePreview';
import { useValidatePageName } from '../../content/contentPage/editPageUtils';
import { PageBlocks } from '../../content/contentPage/PageBlocks';
import { PageName } from '../../content/contentPage/PageName';

export const PagesNew = React.memo(() => {
    const client = useClient()
    const history = useHistory()
    const [loading, setLoading] = useState(false) //todo useSuspense

    const [name, setName] = useState('')
    const [blocks, setBlocks] = useState<ViewConfig.NodeBlockExtended[]>([])
    const [pageNeedSave, setPageNeedSave] = useState(false)
    const [errorMsg, clean, verifyName] = useValidatePageName(name)

    useEffect(clean, [name])
    useEffect(() => setPageNeedSave(!!name.trim().length || !!blocks.length), [name, blocks])

    const onSubmit = useCallback(() => {
        if (verifyName()) {
            setPageNeedSave(false)
            setLoading(true)
            client.mutateCreatePage({
                input: ViewConfig.PageToInputPage.encode({
                    id: 'new',
                    name,
                    type: ContentPageType.BLOCK,
                    blocks,
                    contentPageId: 'new'
                }),
            }).then(({pageCreate}) => {
                const location = {
                    ...history.location,
                    pathname: `/pages/${pageCreate.id}`,
                }
                history.replace(location)
            }).finally(() => {
                setLoading(false)
                setPageNeedSave(true)
            })
        }

    }, [client, blocks, name])

    return (
        <Page title="Add new page"
              breadcrumbs={[{content: 'Pages', url: '/pages'}]}
              primaryAction={{content: 'Create', onAction: onSubmit}}>
            {loading && <Loading/>}
            <PhonePreviewLayout applicationId={'unknown'}>
                <Layout.Section>
                    <Card>
                        <Prompt message={'All changes will be lost'} when={pageNeedSave}/>
                        <PageName name={name} onChange={setName} errorMsg={errorMsg || false}/>
                    </Card>
                    <Card title="Page content">
                        <PageBlocks blocks={blocks} onChange={setBlocks}/>
                    </Card>
                </Layout.Section>
            </PhonePreviewLayout>
        </Page>
    )
});